import script from "./DailyReportView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DailyReportView.vue?vue&type=script&setup=true&lang=ts"

import "./DailyReportView.vue?vue&type=style&index=0&id=8356f982&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8356f982"]])

export default __exports__